import React from "react";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import "./Alert.css";

/**
 * Reusable Alert component for displaying error/warning messages
 * @param {string} message - The message to display
 * @param {string} variant - The alert variant: "error" (default)
 */
const Alert = ({ message, variant = "error" }) => {
  if (!message) return null;

  const displayMessage =
    typeof message === "object" && message.message
      ? message.message
      : message;

  return (
    <div className={`alert-banner alert-${variant}`}>
      <ExclamationCircleFill />
      <div>{displayMessage}</div>
    </div>
  );
};

export default Alert;
